app.controller('teacherAppExercisesCtrl', [
    '$scope', '$interval', 'gameService', '$state', '$stateParams', function ($scope, $interval, gameService, $state, $stateParams) {
        $scope.gameService = gameService;

        $scope.go = function() {
        	var exerciseIndex = $scope.gameService.gameState.exerciseIndex;
        	var questionIndex = $scope.gameService.gameState.questionIndex;
        	var evaluationQuestionIndex = $scope.gameService.gameState.evaluationQuestionIndex;

			var exercise = gameService.exerciseWithIndex(exerciseIndex);

			console.log(exerciseIndex);
			console.log(questionIndex);
			console.log(evaluationQuestionIndex);

			if (questionIndex == 0 && evaluationQuestionIndex == 0) {
	            $state.go('student.exercisemap', {id: exerciseIndex});
	        } else if (questionIndex > 0 && questionIndex != exercise.questions.length && evaluationQuestionIndex == 0) {
	        	$state.go('student.exerciseperform', {id: exerciseIndex, question: questionIndex });
	        } else if (questionIndex == exercise.questions.length && evaluationQuestionIndex == 0) {
	        	$state.go('student.exerciseevalbegin', { id: exerciseIndex });
	        } else if (questionIndex == exercise.questions.length && evaluationQuestionIndex > 0) {
	        	$state.go('student.exerciseevalperform', { id: exerciseIndex, question: evaluationQuestionIndex });
	        }
	    }
    }
]);